// PowerSync client SQLite schema (local-first migration, Phase 3).
//
// Mirrors the SYNCED columns from sync_rules.yaml. PowerSync auto-creates the
// `id` TEXT primary key for every table, so it is NOT declared here. JSON
// columns are stored as TEXT (parse/stringify in app code); booleans as INTEGER
// (0/1); timestamps as TEXT (ISO-8601). Secrets are intentionally absent —
// they are never synced to clients.
import { column, Schema, Table } from '@powersync/web';

const cues = new Table(
  {
    show_id: column.text,
    order: column.integer,
    label: column.text,
    cue_type: column.text,
    status: column.text,
    planned_duration: column.integer,
    actual_duration: column.integer,
    script: column.text,
    top_right_logo: column.text,
    bottom_right_logo: column.text,
    other_graphics: column.text,
    notes: column.text,
    colour: column.text,
    enabled: column.integer,
    parent_id: column.text,
    cue_actions: column.text,
    loop_mode: column.text,
    vmix_actions: column.text,
    singular_action: column.text,
    last_edited_by: column.text,
    created_at: column.text,
    updated_at: column.text,
    deleted_at: column.text,
  },
  { indexes: { by_show: ['show_id'] } }
);

const shows = new Table(
  {
    workspace_id: column.text,
    name: column.text,
    sport_type: column.text,
    scheduled_start: column.text,
    scheduled_duration_seconds: column.integer,
    status: column.text,
    vmix_host: column.text,
    vmix_port: column.integer,
    singular_output_id: column.text,
    sheets_url: column.text,
    actual_start: column.text,
    actual_end: column.text,
    created_at: column.text,
    updated_at: column.text,
    deleted_at: column.text,
  },
  { indexes: { by_workspace: ['workspace_id'] } }
);

const cue_blocks = new Table(
  {
    workspace_id: column.text,
    name: column.text,
    description: column.text,
    cues: column.text,
    created_at: column.text,
    updated_at: column.text,
    deleted_at: column.text,
  },
  { indexes: { by_workspace: ['workspace_id'] } }
);

const users = new Table(
  {
    workspace_id: column.text,
    email: column.text,
    name: column.text,
    avatar_url: column.text,
    global_role: column.text,
    created_at: column.text,
    updated_at: column.text,
  },
  { indexes: { by_workspace: ['workspace_id'] } }
);

const workspaces = new Table({
  name: column.text,
  organisation_id: column.text,
  created_at: column.text,
  updated_at: column.text,
});

export const AppSchema = new Schema({ cues, shows, cue_blocks, users, workspaces });
